import React from "react";
import { Helmet } from "react-helmet";
import { useLocale } from "../../lang/languages";

/* Métadonnées d'indexation par page.
   - Pages publiques : <PageSeo path="/help" /> → canonical + hreflang (6 langues
     + x-default) + og:url pour l'URL localisée courante.
   - Pages privées (compte) : <PageSeo noindex /> → robots noindex,nofollow,
     pas de canonical (elles ne doivent jamais apparaître dans Google).
   - title (optionnel, déjà traduit) : titre d'onglet « <title> | 2FASMS ».
     Sans lui, l'onglet garde le titre par défaut traduit (HtmlLang). */

const SITE = "https://2fasms.com";
const LANGS = ["en", "fr", "es", "ru", "ar", "zh"];

const PageSeo = ({ path = "", noindex = false, title }) => {
  const { locale } = useLocale();
  const lang = LANGS.includes(locale) ? locale : "en";
  const titleTag = title ? (
    <Helmet defer={false}>
      <title>{`${title} | 2FASMS`}</title>
    </Helmet>
  ) : null;

  if (noindex) {
    return (
      <>
        <Helmet defer={false}>
          <meta name="robots" content="noindex, nofollow" />
        </Helmet>
        {titleTag}
      </>
    );
  }

  const url = `${SITE}/${lang}${path}`;
  const seo = (
    <Helmet defer={false}>
      <link rel="canonical" href={url} />
      {LANGS.map((l) => (
        <link key={l} rel="alternate" hrefLang={l} href={`${SITE}/${l}${path}`} />
      ))}
      <link rel="alternate" hrefLang="x-default" href={`${SITE}/en${path}`} />
      <meta property="og:url" content={url} />
    </Helmet>
  );
  return titleTag ? <>{seo}{titleTag}</> : seo;
};

export default PageSeo;
